import { useEffect, useState } from 'react'
import { supabase, readableError } from '../lib/supabase'
import { useSession } from '../lib/session'
import { Shell } from './Shell'
import { Field, Button, Sill } from './ui'

/**
 * Blocks every screen behind <Only>/<Platform>/<Gate> until a verified TOTP
 * factor's code is entered. Shown once per session, not once per app open —
 * the assurance level lives on the Supabase session, so it survives a tab
 * refresh and is only asked again after a real sign-out/sign-in.
 */
export default function MfaChallenge() {
  const { recheckMfa, signOut } = useSession()
  const [factorId, setFactorId] = useState(null)
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)

  useEffect(() => {
    supabase.auth.mfa.listFactors().then(({ data, error }) => {
      if (error) return setErr(readableError(error))
      setFactorId(data.totp.find((f) => f.status === 'verified')?.id ?? null)
    })
  }, [])

  const confirm = async (e) => {
    e.preventDefault()
    setBusy(true); setErr(null)
    const { data: ch, error: chErr } = await supabase.auth.mfa.challenge({ factorId })
    if (chErr) { setBusy(false); return setErr(readableError(chErr)) }
    const { error } = await supabase.auth.mfa.verify({ factorId, challengeId: ch.id, code })
    setBusy(false)
    if (error) { setCode(''); return setErr(readableError(error)) }
    recheckMfa()
  }

  return (
    <Shell>
      <div className="eyebrow">One more step</div>
      <h2 className="q">Enter your code.</h2>
      <p className="sub">Open your authenticator app and type the current 6-digit code.</p>
      <Sill />
      <form onSubmit={confirm} style={{ marginTop: 18 }}>
        <Field label="6-digit code">
          <input className="input" inputMode="numeric" maxLength={6} autoFocus
                 value={code} placeholder="000000"
                 onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} />
        </Field>
        <Button busy={busy} disabled={!factorId || code.length !== 6}>Verify</Button>
        {err && <p className="err">{err}</p>}
      </form>
      <button className="btn-plain" style={{ width: '100%', marginTop: 8 }} onClick={signOut}>
        Sign out instead
      </button>
    </Shell>
  )
}
